import { useFormikContext } from 'formik';

import { Button } from '@src/design-system/button';
import { Label } from '@src/design-system/label';
import { Textfield } from '@src/shared/fields/text-field';
import { cn } from '@src/design-system/helpers';

const reminderFrequencyOptions = ['1', '2', '5', '10'];

type OtherRuleRepetitionFormValues = {
  frequency?: string | number;
  frequency_count?: number;
};

export function OtherRuleRepetitionFields() {
  const { values, setFieldValue } =
    useFormikContext<OtherRuleRepetitionFormValues>();

  const handleFrequencySelect = (value: string) => {
    setFieldValue('frequency', value);
  };

  const isFrequencySelected = (value: string) => {
    return String(values.frequency) === String(value);
  };

  return (
    <div className='flex flex-col gap-6'>
      <div className='flex flex-col gap-2'>
        <Label className='mb-0'>Send Reminder Each (Days)</Label>

        <div className='flex items-start gap-2'>
          {reminderFrequencyOptions.map((option) => (
            <Button
              key={option}
              type='button'
              variant={
                isFrequencySelected(option) ? 'primaryPale' : 'primaryOutline'
              }
              size='iconSm'
              onClick={() => handleFrequencySelect(option)}
              className={cn(
                'border-primary-200 rounded-[8px]',
                isFrequencySelected(option) && 'border-primary-800'
              )}
            >
              {option}
            </Button>
          ))}

          <div className='flex-1'>
            <Textfield
              labelProps={{
                className: 'mb-0 hidden',
              }}
              label=''
              size='sm'
              name='frequency'
              type='number'
              placeholder='other'
            />
          </div>
        </div>
      </div>

      <div>
        <Textfield
          label='Frequency Count'
          name='frequency_count'
          type='number'
          placeholder='Add frequency count limit'
        />
      </div>
    </div>
  );
}
